module.exports = __webpack_public_path__ + "static/assets/7cbefacd23f2a211baa0a83f15ac8473.svg";